import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {RepairDto} from "../../../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class GetRepairsAtTimeOfSubmissionService {

  constructor(private httpClient: HttpClient) { }

  public GetRepairsAtTimeOfSubmission(claimId: number): Observable<RepairDto[]> {
    return this.httpClient.get<RepairDto[]>(`${environment.apiServer}/GetRepairsAtTimeOfSubmission`, {params: {claimId: claimId}});
  }
}
